<template>
    <div class="modal_cont smn_modal">
        <div class="smn_title_row">
            <h2 class="smn_title">사업설명회 신청</h2>
            <button type="button" class="smn_close" aria-label="닫기" @click="closeModal"></button>
        </div>

        <div class="modal_content smn_body">
            <div class="smn_intro">
                <p>사업설명회 신청을 하시려면 아래 내용을 입력해 주시기 바랍니다.</p>
            </div>

            <div class="consent_box">
                <div class="consent_info">
                    <h3 class="consent_info_title">개인정보 수집·이용 동의</h3>
                    <ul class="consent_info_list">
                        <li>입력하신 정보는 사업설명회에 의한 확인을 위해서만 사용합니다. 수집항목, 이용 및 목적, 보유 및 이용기간은 다음과 같습니다.<br>기타 개인정보 취급사항은 홈페이지 하단의 "개인정보 취급방침"을 참고하시기 바랍니다.</li>
                        <li>수집하는 개인정보 항목 : 이름, 연락처, E-mail, 지역</li>
                        <li>수집이용 및 목적: 수집된 개인정보를 통한 사업 및 문의사항 확인 및 답변을 위하여 활용</li>
                        <li>보유 및 이용기간: 개인정보 수집 및 이용 목적이 달성된 후에는 예외없이 정보를 파기 합니다.</li>
                    </ul>
                    <div class="consent_notice">
                        <p class="consent_notice_text">고객님께서는 본 동의에 거부하실 권리가 있으나, 동의하지 않으실 경우<br class="p_br">사업설명회 신청 글 작성이 불가능합니다.</p>
                        <label class="consent_radio_label">
                            <input type="radio" class="consent_radio" name="consent_agree" value="agree" v-model="consentAgree" @click="consentAgree = consentAgree === 'agree' ? '' : 'agree'" />
                            <span class="consent_radio_text">동의합니다.</span>
                        </label>
                    </div>
                </div>
            </div>

            <div class="apply_form">
                <div class="form_head">
                    <h3 class="form_head_title">신청하기</h3>
                    <span class="form_required_note">* 필수 입력사항</span>
                </div>
                <div class="form_body">
                    <div class="form_row">
                        <div class="form_label">이름<span class="form_required">*</span></div>
                        <div class="form_field">
                            <Inputs type="text" v-model="seminarForm.name" maxlength="100" />
                        </div>
                    </div>
                    <div class="form_row">
                        <div class="form_label">연락처<span class="form_required">*</span></div>
                        <div class="form_field form_field_phone">
                            <Inputs type="text" v-model="seminarForm.phone1" :is-readonly="true" />
                            <span class="form_sep">-</span>
                            <Inputs
                                type="text"
                                :model-value="seminarForm.phone2"
                                inputmode="numeric"
                                pattern="[0-9]*"
                                maxlength="4"
                                @beforeinput="preventNonDigitInput"
                                @input="handlePhonePartInput($event, 'phone2')"
                                @update:modelValue="seminarForm.phone2 = sanitizePhonePart($event)"
                            />
                            <span class="form_sep">-</span>
                            <Inputs
                                type="text"
                                :model-value="seminarForm.phone3"
                                inputmode="numeric"
                                pattern="[0-9]*"
                                maxlength="4"
                                @beforeinput="preventNonDigitInput"
                                @input="handlePhonePartInput($event, 'phone3')"
                                @update:modelValue="seminarForm.phone3 = sanitizePhonePart($event)"
                            />
                        </div>
                    </div>
                    <div class="form_row">
                        <div class="form_label">이메일<span class="form_required">*</span></div>
                        <div class="form_field form_field_email">
                            <Inputs
                                type="text"
                                :model-value="seminarForm.emailId"
                                :maxlength="emailIdMaxLength"
                                @update:modelValue="seminarForm.emailId = sanitizeEmailId($event)"
                            />
                            <span class="form_sep">@</span>
                            <Inputs
                                v-if="seminarForm.emailDomain === EMAIL_DOMAIN_CUSTOM"
                                type="text"
                                :model-value="seminarForm.emailDomainCustom"
                                :maxlength="emailDomainCustomMaxLength"
                                placeholder="직접입력"
                                @update:modelValue="seminarForm.emailDomainCustom = sanitizeEmailDomainCustom($event)"
                            />
                            <Inputs v-else type="text" :model-value="seminarForm.emailDomain" :is-readonly="true" />
                            <SelectBox :options="emailDomainOptions" v-model="seminarForm.emailDomain" @change="handleEmailDomainChange" />
                        </div>
                    </div>
                    <div class="form_row">
                        <div class="form_label">개설희망지역<span class="form_required">*</span></div>
                        <div class="form_field form_field_region">
                            <SelectBox :options="regionSidoOptions" v-model="seminarForm.regionSido" initMsg="지역선택" @change="selectSidoComboChange" />
                            <SelectBox :options="regionSigunguOptions" v-model="seminarForm.regionSigungu" initMsg="구/군 선택" :is-disabled="!seminarForm.regionSido" />
                        </div>
                    </div>
                    <!-- <div class="form_row">
                        <div class="form_label">재직중인 과거직장</div>
                        <div class="form_field">
                            <Inputs type="text" v-model="seminarForm.prevJob" />
                        </div>
                    </div> -->
                    <div class="form_row form_row_radio">
                        <div class="form_label">사업 설명회 신청<br class="p_br">지역<span class="form_required">*</span></div>
                        <div class="form_field form_field_radio">
                            <Inputs
                                v-for="opt in seminarRegionOptions"
                                :key="opt.value"
                                type="radio"
                                name="seminar_region"
                                :value="opt.value"
                                v-model="seminarForm.seminarRegion"
                                :text="opt.label"
                            />
                        </div>
                    </div>
                    <div class="form_row form_row_textarea">
                        <div class="form_label">내용<span class="form_required">*</span></div>
                        <div class="form_field">
                            <Textarea v-model="seminarForm.content" :placeholder="contentPlaceholder" :rows="6" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="smn_bottom">
            <Buttons btn-class="btn_big fill primary" :disabled="submitting" @click="submitSeminarRequest">신청</Buttons>
            <Buttons btn-class="btn_big gary" @click="closeModal">취소</Buttons>
        </div>
    </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted, onUnmounted, watch } from "vue";
import modal from "@/utils/popupModal";
import Inputs from "@/components/Inputs.vue";
import SelectBox from "@/components/SelectBox.vue";
import Textarea from "@/components/Textarea.vue";
import Buttons from "@/components/Buttons.vue";
import { startupAPI } from "@/api/startupAPI.js";
import { gisAPI } from "@/api/gisAPI.js";
import { COMM_CD_GROUP_IDS, loadCommCdGroupItems } from "@/utils/CommonCode.js";

const consentAgree = ref("");

const MAX_EMAIL_LENGTH = 100;
const EMAIL_DOMAIN_CUSTOM = "custom";

const emailDomainOptions = [
    { value: EMAIL_DOMAIN_CUSTOM, label: "직접입력" },
    { value: "naver.com", label: "naver.com" },
    { value: "hanmail.net", label: "hanmail.net" },
    { value: "hotmail.com", label: "hotmail.com" },
    { value: "nate.com", label: "nate.com" },
    { value: "yahoo.co.kr", label: "yahoo.co.kr" },
    { value: "empas.com", label: "empas.com" },
    { value: "dreamwiz.com", label: "dreamwiz.com" },
    { value: "freechal.com", label: "freechal.com" },
    { value: "lycos.co.kr", label: "lycos.co.kr" },
    { value: "korea.com", label: "korea.com" },
    { value: "gmail.com", label: "gmail.com" },
    { value: "hanmir.com", label: "hanmir.com" },
    { value: "paran.com", label: "paran.com" },
];
const regionSidoOptions = ref([]);
const regionSigunguOptions = ref([]);
const seminarRegionOptions = ref([]);
const submitting = ref(false);

const seminarForm = reactive({
    name: "",
    phone1: "010",
    phone2: "",
    phone3: "",
    emailId: "",
    emailDomain: EMAIL_DOMAIN_CUSTOM,
    emailDomainCustom: "",
    regionSido: "",
    regionSigungu: "",
    prevJob: "",
    seminarRegion: "",
    content: "",
});

const isMobile = ref(false);
const mq = window.matchMedia("(max-width: 768px)");
function onMqChange(e) { isMobile.value = e.matches; }
onMounted(() => {
    isMobile.value = mq.matches;
    mq.addEventListener("change", onMqChange);
    loadRegionOptions();
});
onUnmounted(() => { mq.removeEventListener("change", onMqChange); });

watch(
    () => seminarForm.phone1,
    () => { seminarForm.phone1 = "010"; }
);

const contentPlaceholder = computed(() =>
    isMobile.value
        ? "개설 희망 타입을 적어주세요.\n(타입 GSF1, GSF2, GSF3)"
        : "개설 희망 타입을 적어주세요. (타입 GSF1, GSF2, GSF3)"
);

function closeModal(eventOrElement) {
    const targetElement = eventOrElement?.currentTarget || eventOrElement?.target || eventOrElement;

    if (targetElement) {
        modal.close(targetElement);
    }
}

async function loadRegionOptions() {
    const codeItems = await loadCommCdGroupItems({
        regionSidoItems: COMM_CD_GROUP_IDS.GS25_BRFS_REGN_DV_CD,
        seminarRegionItems: COMM_CD_GROUP_IDS.GSF_BRFS_REGN_DV_CD,
    });

    regionSidoOptions.value = codeItems.regionSidoItems.filter(item => item.value !== '46' && item.value !== '29').map(toSelectOption);
    seminarRegionOptions.value = codeItems.seminarRegionItems.map((item) => ({
        value: item.value,
        label: item.title === '중부(충청, 강원, 제주)' ? '중부(충청, 강원)' : item.title,
    }));
}

function toSelectOption(item) {
    return {
        value: item.value,
        label: item.title,
    };
}

const excludeValues = new Set(['4473','4483', '4374', '4378','4371','4179','4171','4173','4181','4175','2811','2826','2897','2814','4772','4816','4815','4811','4819']);

async function selectSidoComboChange() {
    seminarForm.regionSigungu = "";
    regionSigunguOptions.value = [];

    if (!seminarForm.regionSido) return;

    try {
        const response = await gisAPI.searchGungu({ sido: seminarForm.regionSido });
        if (response.data.resultCode === "00000") {
            regionSigunguOptions.value = (response.data.result || []).filter(gungu =>  !excludeValues.has(gungu.gunguCd)).map((gungu) => ({
                value: gungu.gunguCd,
                label: gungu.gunguNm,
            }));
        }
    } catch (error) {
        // console.error("시군구 목록 조회 오류:", error);
        return null;
    }
}

function validateSeminarForm() {
    if (consentAgree.value !== "agree") return "개인정보 수집 및 이용에 동의해 주세요.";
    if (!seminarForm.name.trim()) return "이름을 입력해 주세요.";
    if (!seminarForm.phone2.trim() || !seminarForm.phone3.trim()) return "연락처를 입력해 주세요.";
    if (!seminarForm.emailId.trim()) return "이메일을 입력해 주세요.";
    if (!emailDomain.value) return "이메일 도메인을 입력해 주세요.";
    if (!seminarForm.regionSido || !seminarForm.regionSigungu) return "개설희망지역을 선택해 주세요.";
    if (!seminarForm.seminarRegion) return "사업 설명회 신청 지역을 선택해 주세요.";
    if (!seminarForm.content.trim()) return "내용을 입력해 주세요.";

    return "";
}

const emailDomain = computed(() =>
    seminarForm.emailDomain === EMAIL_DOMAIN_CUSTOM
        ? seminarForm.emailDomainCustom.trim()
        : seminarForm.emailDomain
);

const emailIdMaxLength = computed(() =>
    Math.max(MAX_EMAIL_LENGTH - emailDomain.value.length - 1, 0)
);

const emailDomainCustomMaxLength = computed(() =>
    Math.max(MAX_EMAIL_LENGTH - seminarForm.emailId.trim().length - 1, 0)
);

function sanitizePhonePart(value) {
    return String(value ?? "").replace(/\D/g, "").slice(0, 4);
}

function preventNonDigitInput(event) {
    if (event.inputType?.startsWith("delete") || !event.data) return;
    if (/\D/.test(event.data)) event.preventDefault();
}

function handlePhonePartInput(event, fieldName) {
    const value = sanitizePhonePart(event.target.value);
    event.target.value = value;
    seminarForm[fieldName] = value;
}

function sanitizeEmailId(value) {
    return String(value ?? "").slice(0, emailIdMaxLength.value);
}

function sanitizeEmailDomainCustom(value) {
    return String(value ?? "").slice(0, emailDomainCustomMaxLength.value);
}

function handleEmailDomainChange(value) {
    if (value !== EMAIL_DOMAIN_CUSTOM) seminarForm.emailDomainCustom = "";
    trimEmailToMaxLength();
}

function getSubmitFailureMessage(response, fallbackMessage) {
    const data = response?.data || {};

    if (data.result === false) return data.message || data.resultMessage || fallbackMessage;
    if (data.resultCode && data.resultCode !== "00000") return data.resultMessage || data.message || fallbackMessage;

    return "";
}

function trimEmailToMaxLength() {
    if (seminarForm.emailId.length > emailIdMaxLength.value) {
        seminarForm.emailId = seminarForm.emailId.slice(0, emailIdMaxLength.value);
    }

    if (seminarForm.emailDomain === EMAIL_DOMAIN_CUSTOM && seminarForm.emailDomainCustom.length > emailDomainCustomMaxLength.value) {
        seminarForm.emailDomainCustom = seminarForm.emailDomainCustom.slice(0, emailDomainCustomMaxLength.value);
    }
}

function createSubmitPayload() {
    trimEmailToMaxLength();

    return {
        wrtrNm: seminarForm.name.trim(),
        wrtrEmailAddr: `${seminarForm.emailId.trim()}@${emailDomain.value}`,
        wrtrTelno: [seminarForm.phone1, seminarForm.phone2.trim(), seminarForm.phone3.trim()].join("-"),
        gsfBrfsAceptStatCd: "01",
        regnCd: seminarForm.regionSido,
        borCd: seminarForm.regionSigungu,
        rqtRegnCd: seminarForm.seminarRegion,
        inqryCntnt: seminarForm.content.trim(),
        seminaNm: regionName.value,
    };
}

const regionName = computed(() => {
    const prod = seminarRegionOptions.value.find(item => item.value === seminarForm.seminarRegion)

    const name1 = prod ? prod.label : ''

    return name1
}) 

async function submitSeminarRequest(event) {
    const targetElement = event?.currentTarget;

    const validationMessage = validateSeminarForm();
    if (validationMessage) {
        alert(validationMessage);
        return;
    }

    if (submitting.value) return;
    submitting.value = true;

    try {
        const response = await startupAPI.insertGtfBriefingSessionRequest(createSubmitPayload());
        const failureMessage = getSubmitFailureMessage(response, "사업설명회 신청에 실패했습니다.");

        if (failureMessage) {
            alert(failureMessage);
            return;
        }

        alert("사업설명회 신청이 완료되었습니다.");
        closeModal(targetElement);
    } catch (error) {
        // console.error("사업설명회 신청 오류:", error);
        alert("사업설명회 신청 중 오류가 발생했습니다.");
    } finally {
        submitting.value = false;
    }
}
</script>

<style scoped>
.smn_modal { --color-brand-primary: #15b874; }
.smn_modal :deep([class*="btn_"][class*="primary"]) { color: #fff; background-color: var(--color-brand-primary); }
.modal_content { border-bottom: 1px solid #E5E5E9; }
.smn_title_row { display: flex; align-items: flex-start; justify-content: space-between; min-height: 92px; margin: 0; padding: 0; }
.smn_title { color: #161616; font-size: 4rem; font-weight: 700; letter-spacing: -0.01em; line-height: 1.3; }
.smn_close { width: 40px; height: 40px; background: none; border: none; border-radius: 50%; cursor: pointer; flex-shrink: 0; position: relative; }
.smn_close::before, .smn_close::after { width: 22px; border-top: 2px solid #161616; content: ""; position: absolute; top: 50%; left: 50%; }
.smn_close::before { transform: translate(-50%, -50%) rotate(45deg); }
.smn_close::after { transform: translate(-50%, -50%) rotate(-45deg); }
.smn_intro > p { color: #161616; font-size: 2rem; font-weight: 400; letter-spacing: -0.01em; line-height: 1.35; }
.consent_box { margin-top: 40px; border-radius: 12px; background-color: #f8f8f8; overflow: hidden; }
.consent_info { padding: 32px; }
.consent_info_title { color: #161616; font-size: 2.4rem; font-weight: 700; letter-spacing: -0.01em; line-height: 1.35; }
.consent_info_list { margin-top: 24px; display: flex; flex-direction: column; gap: 8px; }
.consent_info_list > li { padding-left: 10px; color: #67676f; font-size: 1.6rem; font-weight: 400; letter-spacing: -0.01em; line-height: 1.5; position: relative; }
.consent_info_list > li::before { content: ""; width: 4px; height: 1px; background-color: #67676f; position: absolute; left: 0; top: 0.5lh; }
.consent_notice { margin-top: 24px; padding-top: 24px; border-top: 1px solid #d7d7df; display: flex; align-items: center; justify-content: space-between; gap: 16px; }
.consent_notice_text { color: #161616; font-size: 1.6rem; font-weight: 700; line-height: 1.24; }
.consent_radio_label { display: flex; align-items: center; gap: 8px; flex-shrink: 0; cursor: pointer; white-space: nowrap; }
/*.consent_radio { width: 24px; height: 24px; padding: 0; appearance: none; border: 0; border-radius: 8px; background-color: #fff; cursor: pointer; flex-shrink: 0; position: relative; transition: border-color 0.2s, background-color 0.2s; }
.consent_radio:checked { border-color: #107af2; background-color: #107af2; }
.consent_radio:checked::after { width: 13px; height: 8px; background-color: #fff; content: ""; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); }
.consent_radio_text { color: #161616; font-size: 1.8rem; font-weight: 400; line-height: 1.4; }*/
.consent_radio, .consent_radio + .consent_radio_text:before {width:24px; height:24px;padding: 0;border: 0; background:url('@/assets/images/common/bg_input_check.png') -10px -10px no-repeat; box-sizing:border-box; top:0; left:0;}
.consent_radio:checked, .consent_radio:checked + .consent_radio_text:before {background-position:-141px -10px;}
.consent_radio:disabled, .consent_radio:disabled + .consent_radio_text:before {background-position:-272px -10px; cursor:default;}
.consent_radio:disabled, .consent_radio:checked:disabled + .consent_radio_text:before {background-position:-403px -10px; cursor:default;}
.consent_radio_text { font-size: 1.8rem; font-weight: 400; line-height: 1.4; color: #161616; }
.apply_form { margin-top: 40px; }
.form_head { height: 48px; padding-bottom: 16px; border-bottom: 1px solid #242428; display: flex; align-items: center; justify-content: space-between; }
.form_head_title { color: #161616; font-size: 2.4rem; font-weight: 700; letter-spacing: -0.01em; line-height: 1.35; }
.form_required_note { color: #fb6432; font-size: 1.4rem; line-height: 1.4; }
.form_body { padding: 12px 0; border-top: 1px solid #e5e5e9; }
.form_row { min-height: 52px; padding: 12px 0; display: grid; grid-template-columns: 134px 1fr; align-items: center; gap: 0 8px; }
.form_row_radio, .form_row_textarea { align-items: start; }
.form_label { color: #161616; font-size: 1.6rem; font-weight: 400; letter-spacing: -0.01em; line-height: 1.5; }
.form_required { margin-left: 2px; color: #fb6432; }
.form_field { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; min-width: 0; }
.form_field > :deep(.input_wrap) { flex: 1; min-width: 0; }
.form_sep { color: #67676f; font-size: 1.6rem; flex-shrink: 0; }
.form_field_phone :deep(.select) { width: 134px; flex-shrink: 0; }
.form_field_phone :deep(.select select) { width: 100%; font-size: 1.6rem; }
.form_field_phone > :deep(.input_wrap) { max-width: 134px; flex: 1; min-width: 80px; }
.form_field_email { align-items: center; }
.form_field_email > :deep(.input_wrap:nth-child(1)) { flex: 0 0 205px; width: 205px; min-width: 0; }
.form_field_email > :deep(.input_wrap:nth-child(3)) { flex: 0 0 180px; width: 180px; min-width: 0; }
.form_field_email :deep(.select) { flex: 0 0 180px; width: 180px; min-width: 0; }
.form_field_email :deep(.select select) { width: 100%; font-size: 1.6rem; }
.form_field_region { flex-wrap: nowrap; }
.form_field_region :deep(.select) { flex: 1; min-width: 0; }
.form_field_region :deep(.select select) { width: 100%; font-size: 1.6rem; }
.form_field_radio { padding: 13px 0; gap: 8px; }
.form_field_radio :deep(.input_wrap) { width: auto; flex: 0 0 auto; }
.form_field_radio :deep(.check) { gap: 8px; white-space: nowrap; cursor: pointer; }
.form_field_radio :deep(.label) { font-size: 1.8rem; color: #161616; }
.form_row_textarea .form_field { display: block; }
.form_field > :deep(.textarea_wrap) { width: 100%; }
.smn_bottom { margin-top: 40px; flex-shrink: 0; display: flex; align-items: center; justify-content: flex-end; gap: 8px; }
.smn_bottom > :deep(.btn_big) { width: 134px; text-align: center; font-size: 1.6rem; line-height: 1.5; letter-spacing: -0.01em; }

@media (max-width: 768px) {
    .modal_wrap .modal_container { padding-bottom: 32px; }
    .smn_title_row { min-height: 60px; margin: 0 -20px; padding: 17px 20px; border-bottom: 1px solid #c4c4d0; }
    .smn_title { font-size: 1.8rem; line-height: 1.4; }
    .smn_close { width: 24px; height: 24px; }
    .smn_intro { display: none; }
    .consent_info { padding: 30px 20px; }
    .consent_info_list > li { font-size: 1.4rem; line-height: 1.4; letter-spacing: -0.01em; }
    .consent_info_title { font-weight: 700; font-size: 1.8rem; line-height: 1.5; }
    .consent_notice { flex-direction: column; align-items: flex-start; gap: 16px; }
    .consent_notice_text { font-size: 1.4rem; line-height: 1.4; }
    .form_head { height: auto; padding-bottom: 12px; }
    .form_head_title { font-size: 2rem; }
    .form_body { padding: 30px 0; }
    .form_row { padding: 20px 0; grid-template-columns: 1fr; gap: 0; }
    .form_row:first-child { padding-top: 0; }
    .form_row:last-child { padding-bottom: 0; }
    .form_field_phone > :deep(.input_wrap) { max-width: none; flex: 1; }
    .form_field_email > :deep(.input_wrap:nth-child(1)) { flex: 1; min-width: 80px; }
    .form_field_email > :deep(.input_wrap:nth-child(3)) { flex: 1; min-width: 60px; }
    .form_field_email :deep(.select) { flex: 1 0 100%; width: 100%; }
    .form_field_region { flex-wrap: wrap; }
    .form_field_region :deep(.select) { flex: 1 0 100%; width: 100%; }
    .form_label { margin-bottom: 12px; }
    .consent_radio { width: 20px; height: 20px; }
    .consent_radio_text { font-size: 1.6rem; }
    .form_field_radio { flex-direction: column; gap: 20px; align-items: flex-start; }
    .form_field_radio :deep(.label) { font-size: 1.6rem; letter-spacing: -0.01em; line-height: 1.5; }
    .smn_bottom { justify-content: center; }
    .smn_bottom > :deep(.btn_big) { width: 100%; flex: 1; }
}
</style>
